// @ts-nocheck

import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import { externalLinkOpen } from '../../actions/externallink';
import { Overlay } from '../../components/Modal/Modal.style';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';

import NavigationBurgerMenu from './NavigationBurgerMenu';
import selectNavigationBurgerMenuProps from './NavigationBurgerMenu.selector';

const openingDuration = 250;

export const MenuWrapper = styled.div`
  background-color: #333;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 18em;
  width: calc(18em + constant(safe-area-inset-left));
  width: calc(18em + env(safe-area-inset-left));
  z-index: 150;

  /* Prevent elements to be highlighted on tap */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  /* Transition */
  transition-property: transform, opacity;
  transition-duration: ${({ $timingDuration }) => ($timingDuration ? `${$timingDuration}ms` : '1250ms')};
  transition-timing-function: ease-in-out;
  ${({ $isOpen }) =>
    $isOpen
      ? css`
          transform: translateX(0%);
          opacity: 1;
        `
      : css`
          transform: translateX(-100%);
          opacity: 0.5;
        `}
`;

type PropsType = {
  isOpen: boolean;
  toggleMenu: () => void;
};

const NavigationBurgerMenuWrapper = ({ isOpen, toggleMenu, items }: PropsType & { items: Array<unknown> }) => {
  const onOverlayClick = useCallback(() => {
    if (isOpen) {
      toggleMenu();
    }
  }, [isOpen, toggleMenu]);

  return (
    <>
      <Overlay $zIndex={150} $isOpen={isOpen} $timingDuration={openingDuration} onClick={onOverlayClick} />
      <MenuWrapper $isOpen={isOpen} $timingDuration={openingDuration}>
        <NavigationBurgerMenu items={items} />
      </MenuWrapper>
    </>
  );
};

const NavigationBurgerMenuContainer = (ownProps: PropsType) => {
  const dispatch = useDispatch();
  const { history, location } = useRouter();
  const { toggleMenu } = ownProps;

  const openExternalLink = useCallback(
    (url, options) => {
      dispatch(externalLinkOpen(url, options));
    },
    [dispatch],
  );

  const selectedProps = useSelector((state) =>
    selectNavigationBurgerMenuProps(state, { toggleMenu, history, location, openExternalLink }),
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <NavigationBurgerMenuWrapper {...enhancedProps} />;
};

export default NavigationBurgerMenuContainer;
